import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapToolsService} from '../../services/map-tools.service';
import {PermissionsService} from '../../../common/service/permissions.service';

@Component({
    selector: 'nlr-rotate-annotation',
    imports: [CommonModule],
    templateUrl: './rotate-annotation.component.html',
    styleUrl: './rotate-annotation.component.scss'
})
export class RotateAnnotationComponent implements OnInit {
    @Input()
    disabled: boolean;

    title: string = 'RotateAnnotationComponent';

    permissions = ['EDIT_DESIGN', 'VIEW_DESIGN'];

    constructor(
        private mapToolsService: MapToolsService,
        private permissionsService: PermissionsService
    ) {}

    ngOnInit() {
        this.mapToolsService.init(
            'ROTATE',
            () => {},
            () => {},
            () => this.isDisabled()
        );
    }

    getTooltip() {
        return this.mapToolsService.getTooltipWithShortcut('ROTATE', 'Rotate annotation');
    }

    toggle() {
        this.mapToolsService.toggle('ROTATE');
    }

    hasPermission() {
        return this.permissionsService.hasPermission(this.permissions);
    }

    isActive() {
        return !this.mapToolsService.isInactive('ROTATE');
    }

    isDisabled() {
        return this.disabled || !this.permissionsService.hasEditPermission(this.permissions);
    }

    isSuspended() {
        return (
            this.mapToolsService.isSuspended('ROTATE') &&
            (!this.mapToolsService.isActive('PAN') || this.mapToolsService.getActiveToolsThatSuspend('ROTATE').length > 1)
        );
    }
}
